import { useTranslation } from "react-i18next";
import { SceneWeather as SceneWeatherType } from "@ltypes/scene";
import DisplayForm from "@components/forms/DisplayForm/DisplayForm";
import TextField from "@components/forms/TextField/TextField";
import SearchItem, { SearchItemType } from "@components/forms/SearchItem/SearchItem";
import Switch from "@components/forms/Switch/Switch";
import Product, { ProductModelType } from "@ltypes/product";
import { useSelector } from "react-redux";
import { displayModes } from "../../../constants";

type SceneWeatherProps = {
    scene: SceneWeatherType,
    onChange: (field: string, value: string|number|boolean) => void,
};

function SceneWeather(props: SceneWeatherProps) {

    const { t } = useTranslation();
    const product: Product = useSelector((state: any) => state.product);

    const handleChangePlace = (values: Array<SearchItemType>) => {
        if(values.length === 0)
            return;
        props.onChange('place_id', values[0].id);
        props.onChange('place_name', values[0].label);
    };

    return (
        <div className="row g-3">
            <div className="col-12 col-md-6">
                <div className="row g-3">
                    <div className="col-12">
                        <DisplayForm label={t('page.scenes.data.display_mode')} value={props.scene.display_mode} items={displayModes[product.model.type].weather.map((index: number) => ({
                            id: index,
                            background: `weather-${index}`,
                        }))} productModelType={product.model.type} onChange={(value: number) => props.onChange('display_mode', value)}/>
                    </div>
                    <div className="col-12">
                        <TextField label={t('page.scenes.data.display_duration')} value={props.scene.display_duration} onChange={(value: string) => props.onChange('display_duration', value)}/>
                    </div>
                </div>
            </div>
            <div className="col-12 col-md-6">
                <div className="row g-3">
                    <div className="col-12">
                        <SearchItem
                            label={t('page.scenes.data.place')}
                            values={[{id: props.scene.place_id, label: props.scene.place_name, description: props.scene.place_country}]}
                            path="/places"
                            btnSearchText={t('page.scenes.data.choose_place')}
                            searchPlaceholder={t('page.scenes.data.search_place')}
                            onChange={handleChangePlace}
                        />
                    </div>
                    {(product.model.type === ProductModelType.STANDARD || props.scene.display_mode === 1) && (
                        <div className="col-12">
                            <Switch label={t('page.scenes.data.show_place_name')} checked={props.scene.show_place_name} onChange={(checked: boolean) => props.onChange('show_place_name', checked)}/>
                        </div>
                    )}
                    {product.model.type === ProductModelType.STANDARD && (
                        <>
                            <div className="col-12">
                                <Switch label={t('page.scenes.data.show_humidity')} checked={props.scene.show_humidity} onChange={(checked: boolean) => props.onChange('show_humidity', checked)}/>
                            </div>
                            <div className="col-12">
                                <Switch label={t('page.scenes.data.show_pressure')} checked={props.scene.show_pressure} onChange={(checked: boolean) => props.onChange('show_pressure', checked)}/>
                            </div>
                            <div className="col-12">
                                <Switch label={t('page.scenes.data.show_wind_speed')} checked={props.scene.show_wind_speed} onChange={(checked: boolean) => props.onChange('show_wind_speed', checked)}/>
                            </div>
                            <div className="col-12">
                                <Switch label={t('page.scenes.data.show_wind_direction')} checked={props.scene.show_wind_direction} onChange={(checked: boolean) => props.onChange('show_wind_direction', checked)}/>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}

export default SceneWeather;
